<template>
    <transition-group name="fade" tag="header" v-if="sub_class != 'display-none'" :class="['heading', sub_class]">
        <div
            class="slide"
            v-for="(slide, index) in slides"
            v-if="slide == slides[curreentSlide]"
            :key="curreentSlide"
        >
            <div class="container">
                <h2
                  :class="['title', slide.slide_theme === 'light' ? 'title--light' : 'title--dark']"
                  >
                    <div v-html="slide.text" />
                </h2>
            </div>
            <div
                :class="['bg', slide.slide_theme === 'light' ? 'bg--light' : 'bg--dark']"
                v-if="slide.slide_type != 'video'"
                :style="{ 'background-image': 'url( '+ slide.image.url +' )', 'background-position': slide.horizontal_position+'% '+slide.vertical_position+'%' }"
            ></div>
            <video
              :class="['bg', slide.slide_theme === 'light' ? 'bg--light' : 'bg--dark']"
              v-if="slide.slide_type === 'video'"
              :poster="slide.image.url"
              autoplay muted playsinline loop
            >
              <source v-if="slide.video_mp4.url" :src="slide.video_mp4.url" type="video/mp4">
              <source v-if="slide.video_ogg.url" :src="slide.video_ogg.url" type="video/ogg">
              <source v-if="slide.video_webm.url" :src="slide.video_webm.url" type="video/webm">
            </video>
        </div>
    </transition-group>
</template>

<script>
export default {
    props: ["blockdata"],
    name: "block-home-heading",
    data() {
        return {
            slides: this.blockdata.slide,
            sub_class: this.blockdata.class,
            timer: null,
            curreentSlide: 0,
            firstSlide: false
        };
    },
    mounted: function() {
        this.startRotation();
    },
    destroyed: function() {
        clearInterval(this.timer);
    },
    methods: {
        startRotation: function() {
          if(this.slides.length > 1) {
            this.timer = setInterval(this.firstNext, 4000);
          }
        },
        firstNext: function() {
            this.curreentSlide += 1;
            if (this.curreentSlide >= this.slides.length) {
                this.curreentSlide = 0;
            }
            clearInterval(this.timer);
            this.timer = setInterval(this.next, 5000);
        },
        next: function() {
            this.curreentSlide += 1;
            if (this.curreentSlide >= this.slides.length) {
                this.curreentSlide = 0;
            }
        },
    }
};
</script>
<style lang="scss" scope>
.fade-enter-active,
.fade-leave-active {
    transition-property: opacity;
    transition-duration: 0.75s;
}
.fade-leave-active {
    .title {
        transition-property: opacity;
        transition-duration: 0.75s;
        position: absolute;
        left: 5000px;
    }
}
.fade-enter-active {
    transition-delay: 0.75s;
}
.fade-enter,
.fade-leave-active {
    opacity: 0;
}
</style>



// WEBPACK FOOTER //
// BlockHomeHeading.vue?091d4cd0